import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Badge } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/CategoryBadge/components/Badge.js';
import { Container } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/CategoryBadge/components/Container.js';
import { LabelXSmall } from '../../../../../../../../primitives/index.js';
export const CategoryBadge = ({
  label,
  description,
  large = false
}) => {
  return _jsxs(Container, {
    children: [_jsx(Badge, {
      large: large,
      children: label
    }), _jsx(LabelXSmall, {
      color: "contentSecondary",
      children: description
    })]
  });
};